"use client"

import { Home, Building2, Briefcase, Newspaper, Info, Mail } from "lucide-react"
import { Button } from "@/components/ui/button"
import Link from "next/link"
import { usePathname } from "next/navigation"

const navItems = [
  { href: "/", label: "ホーム", icon: Home },
  { href: "/digital-pride", label: "拠点", icon: Building2 },
  { href: "/services", label: "サービス", icon: Briefcase },
  { href: "/news", label: "ニュース", icon: Newspaper },
  { href: "/about", label: "企業情報", icon: Info },
  { href: "/contact", label: "お問合せ", icon: Mail },
]

export function BottomNav() {
  const pathname = usePathname()

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t lg:hidden">
      <div className="grid grid-cols-6" style={{ height: '64px' }}>
        {navItems.map((item) => {
          const isActive = pathname === item.href
          return (
            <Button
              key={item.href}
              variant="ghost"
              className={`h-full rounded-none flex-col gap-1 p-0 ${
                isActive
                  ? "bg-[#292623]/5 text-[#292623]"
                  : "text-muted-foreground hover:bg-[#292623]/5 hover:text-[#292623]"
              }`}
              asChild
            >
              <Link href={item.href}>
                <item.icon className={`w-5 h-5 ${isActive ? "text-[#292623]" : ""}`} />
                <span className={`text-[10px] font-['Noto_Sans_JP',_sans-serif] ${isActive ? "font-semibold text-[#292623]" : ""}`}>
                  {item.label}
                </span>
              </Link>
            </Button>
          )
        })}
      </div>
    </nav>
  )
}
